import { useDisclosure } from '@chakra-ui/react';
import { createContext, useContext, ReactNode } from 'react';

interface SidebarContextType {
  open: boolean;
  onOpen: () => void;
  onClose: () => void;
}

const SidebarContext = createContext<SidebarContextType | undefined>(undefined);

export function SidebarProvider({ children }: { children: ReactNode }) {
  const { open, onOpen, onClose } = useDisclosure();

  return (
    <SidebarContext.Provider value={{ open, onOpen, onClose }}>
      {children}
    </SidebarContext.Provider>
  );
}

export function useSidebar() {
  const context = useContext(SidebarContext);
  if (!context) {
    throw new Error('useSidebar must be used within SidebarProvider');
  }
  return context;
}
